import { authServiceAxiosClient } from '@/lib';
import { AppError, withLogger } from '@/utils';

import { globalLetterAPIUrls } from '../data';
import { EmailTemplate } from '../types';

type Response = {
  message: string;
};

export const deleteEmailTemplate = withLogger(
  async (id: EmailTemplate['id']): Promise<Response> => {
    if (!id)
      throw new AppError({
        type: 'email-template-fetching',
        message: 'Invalid id.',
      });

    const url = globalLetterAPIUrls.emailTemplate.delete.replace('{id}', id);

    const { data } = await authServiceAxiosClient.delete<Response>(url);
    return data;
  },
);
